<template>
	<Modal modal-size="md" :is-modal-open="isOpen" :on-close="onClose">
		<!-- Modal title / header -->
		<h1 class="modal__content__header">{{ header }}</h1>

		<div class="modal__content__body">
			<p style="padding-bottom:20px;">{{ msg }}</p>
			<a class="brand-link" href="mailto:customerservice@avana.com">customerservice@avana.com</a>
		</div>
	</Modal>
</template>

<script>
import Modal from '@/components/shared/Modal';

export default {
	computed: {
		header() {
			return this.$store.AppState.data.appModalTitle || '!';
		},
		msg() {
			return this.$store.AppState.data.appModalMsg;
		},
		isOpen() {
			// The modal should only be open if the message has something to show
			return !!this.msg;
		}
	},
	methods: {
		onClose() {
			// Execute a custom action before closing the modal, if desired
			if (this.$store.AppState.data.appModalFn) {
				this.$store.AppState.data.appModalFn();
			}

			// Clear out the message, which closes the modal
			this.$store.AppState.showModalMsg('', '', null);
		}
	},
	components: {
		Modal
	}
};
</script>
